import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TmsAmbarRafService } from '../ctl-tms-ambar-raf.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private tmsAmbarRafService: TmsAmbarRafService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
            ]);
            const filterArr = [];
            if (this.tmsAmbarRafService.bolumCode) filterArr.push(['BolumKod', '=', this.tmsAmbarRafService.bolumCode]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
